import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import { Helmet } from 'react-helmet';
import "./GalleryPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {Videos_main} from "../../data";
import ReactPlayer from "react-player";
import GalleryPageCards from '../../Common/GalleryPageVideoCards';


//import {Link} from "react-router-dom";

function App() {
  return <X05GalleryPageDesktop {...x05GalleryPageDesktopData} />;
}

export default App;

function X05GalleryPageDesktop(props) {
  const {
    videos,
    vector2,
    group216,
    text551,
    latestVideos,
    address,
    antDesignPlayCircleOutlined,
    text588,
    text5882,
    text5883,
    text5884,
    //line4,
    //line5,
    //line6,
    //line7,
    vector3,
    group,
    //line8,
    youtubeCardProps,
    youtubeCard2Props,
    youtubeCard3Props,
    youtubeCardProps2,
    youtubeCard2Props2,
    youtubeCard3Props2,
    button22Props,
    youtubeCardProps3,
    youtubeCard2Props3,
    youtubeCard3Props3,
    button82Props,
    //footer32Props,
    //headerWithBackground9Props,
  } = props;

  return (
    <div className="gpd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | Videos</title>
        <meta name="keywords" content="Residential construction, house construction, commercial construction, house construction, building construction, interior designing, Apartments" />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="gpd-x05-gallery-page-desktop">
        <div className="gpd-overlap-group">
          <div className="gpd-frame-1576">
            <div className="gpd-overlap-group1">
              <h1 className="gpd-title gpd-valign-text-middle gpd-typographyheadlineh2-extrabold-40">{videos}</h1>
              <div className="gpd-group-182">
                <div className="gpd-chevronleftblack24dp-1">
                  <div className="gpd-overlap-group3">
                    <img
                      className="gpd-vector"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/vector@2x.png"
                    />
                    <img className="gpd-vector-1" src={vector2} />
                  </div>
                </div>
                <div className="gpd-overlap-group2">
                  <img className="gpd-group-216" src={Videos_main.VideoHeaderImage} />
                  {/* <ReactPlayer
                    url={Videos_main.VideosHeader}
                    width='100%'
                    height='469px'
                    playIcon={<img className="gpd-ant-designplay-circle-outlined" src={Videos_main.Play}/>}
                    // light={Videos_main.VideoHeaderImage}
                    light={true}
                    controls={true}
                    playing
                  /> */}
                  {/* <div className="gpd-text-1 gpd-valign-text-middle gpd-overpass-bold-white-40px">{text551}</div>
                  <div className="gpd-latest-videos gpd-valign-text-middle gpd-typographybody16-regular">{latestVideos}</div>
                  <p className="gpd-address gpd-valign-text-middle gpd-overpass-semi-bold-white-16px-22">{address}</p> */}
                  {/* <img className="gpd-ant-designplay-circle-outlined" src={antDesignPlayCircleOutlined} /> */}
                </div>
              </div>
              <div className="gpd-text-38 gpd-typographybody16-regular">
                <p>{text588}</p>
                <p>{text5882}</p>
                <p>{text5883}</p>
                <p>{text5884}</p>
              </div>
                <GalleryPageCards />
                <Button82>{button82Props.children}</Button82>
                {/* <div className="gpd-frame-1568"> */}
                  {/* <YoutubeCard
                    text129={Videos_main.VideosCard1.text129}
                    address={Videos_main.VideosCard1.address}
                    youtubeThumbnailProps= {Videos_main.VideosCard1} //{youtubeCardProps.youtubeThumbnailProps}
                  />
                  <YoutubeCard
                    text129={youtubeCard2Props.text129}
                    address={youtubeCard2Props.address}
                    className={youtubeCard2Props.className}
                    youtubeThumbnailProps={youtubeCard2Props.youtubeThumbnailProps}
                  />
                  <YoutubeCard
                    text129={youtubeCard3Props.text129}
                    address={youtubeCard3Props.address}
                    className={youtubeCard3Props.className}
                    youtubeThumbnailProps={youtubeCard3Props.youtubeThumbnailProps}
                  /> */}
                  {/* {
                    YoutubCards.map( item => (
                      <div className={`gpd-${item.divClass}`}>
                        {
                         item.divData.map( itemdata => (
                        <YoutubeCard
                          text129={itemdata.text129}
                          address={itemdata.address}
                          className={itemdata.className}
                          // youtubeThumbnailProps={itemdata.youtubeThumbnailProps}
                          videourl = {itemdata.videourl}
                        >
                        </YoutubeCard>
                         )
                         )
                        }        
                      </div>      
                    )
                    )
                  } */}

                {/* <div className="gpd-flex-col-1">
                  <YoutubeCard
                    text129={youtubeCardProps2.text129}
                    address={youtubeCardProps2.address}
                    youtubeThumbnailProps={youtubeCardProps2.youtubeThumbnailProps}
                  />
                  <YoutubeCard
                    text129={youtubeCard2Props2.text129}
                    address={youtubeCard2Props2.address}
                    className={youtubeCard2Props2.className}
                    youtubeThumbnailProps={youtubeCard2Props2.youtubeThumbnailProps}
                  />
                  <YoutubeCard
                    text129={youtubeCard3Props2.text129}
                    address={youtubeCard3Props2.address}
                    className={youtubeCard3Props2.className}
                    youtubeThumbnailProps={youtubeCard3Props2.youtubeThumbnailProps}
                  />
                  <Button22>{button22Props.children}</Button22>
                </div>
                <div className="gpd-flex-col-2">
                  <YoutubeCard
                    text129={youtubeCardProps3.text129}
                    address={youtubeCardProps3.address}
                    youtubeThumbnailProps={youtubeCardProps3.youtubeThumbnailProps}
                  />
                  <YoutubeCard
                    text129={youtubeCard2Props3.text129}
                    address={youtubeCard2Props3.address}
                    className={youtubeCard2Props3.className}
                    youtubeThumbnailProps={youtubeCard2Props3.youtubeThumbnailProps}
                  />
                  <YoutubeCard
                    text129={youtubeCard3Props3.text129}
                    address={youtubeCard3Props3.address}
                    className={youtubeCard3Props3.className}
                    youtubeThumbnailProps={youtubeCard3Props3.youtubeThumbnailProps}
                  />
                </div> */}
              {/* </div> */}
             
              {/* <div className="gpd-group-89">
                <img className="gpd-line-4" src={line4} />
                <img className="gpd-line" src={line5} />
                <img className="gpd-line" src={line6} />
                <img className="gpd-line" src={line7} />
                <div className="gpd-bigrid-3x2-gap">
                  <img className="gpd-vector-2" src={vector3} />
                </div>
                <div className="gpd-bigrid-3x2-gap-1">
                  <div className="gpd-group" style={{ backgroundImage: `url(${group})` }}></div>
                </div>
                <img className="gpd-line-8" src={line8} />
              </div> */}
            </div>
            {/* <Footer32
              group32Props={footer32Props.group32Props}
              frame5Props={footer32Props.frame5Props}
              frame6Props={footer32Props.frame6Props}
              frame7Props={footer32Props.frame7Props}
            /> */}
            <Footer />
          </div>
          {/* <HeaderWithBackground9 {...headerWithBackground9Props} /> */}
          <NavBar />
        </div>
      </div>
     
    </div>
  );
}


function YoutubeCard(props) {
  const { text129, address, className, youtubeThumbnailProps, videourl } = props;

  return (
    <div className={`gpd-youtube-card gpd-${className || ""}`}>
      {/* <YoutubeThumbnail
        youtubeThumbnail={youtubeThumbnailProps.youtubeThumbnail}
        className={youtubeThumbnailProps.className}
        antDesignplayCircleOutlinedProps={youtubeThumbnailProps.antDesignplayCircleOutlinedProps}
      /> */}
      <ReactPlayer
        url={videourl}
        width='100%'
        height='300px'
        playIcon={<img src={Videos_main.Play}/>}
        // light={youtubeThumbnailProps.youtubeThumbnail}
        light={true}
        controls={true}
        playing/>

      <div className="gpd-group-162">
        <div className="gpd-text gpd-valign-text-middle gpd-overpass-bold-shark-24px">{text129}</div>
        <p className="gpd-address-1 gpd-valign-text-middle gpd-overpass-semi-bold-scarpa-flow-16px">{address}</p>
      </div>
    </div>
  );
}


function YoutubeThumbnail(props) {
  const { youtubeThumbnail, className, antDesignplayCircleOutlinedProps } = props;

  return (
    <div className={`gpd-youtube-thumbnail ${className || ""}`} style={{ backgroundImage: `url(${youtubeThumbnail})` }}>
      <AntDesignplayCircleOutlined overlapGroup3={antDesignplayCircleOutlinedProps.overlapGroup3} />
    </div>
  );
}


function AntDesignplayCircleOutlined(props) {
  const { overlapGroup3 } = props;

  return (
    <div className="gpd-ant-designplay-circle-outlined-1">
      <div className="gpd-overlap-group2-1" >
        {/* <img className="gpd-vector-3" src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"/> */}
        <img 
        className="gpd-vector-3" 
        src={Videos_main.Play}
        />
      </div>
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27321587TimelineData);
  }, []);

  return (
    <div className="gpd-x27321587 gpd-component gpd-component-wrapper not-ready">
      <div className="gpd-master-button-AvLgq4">
        <div className="gpd-button-i2732158751-67q3SB gpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27321587TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".gpd-x27321587",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


function Button82(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27321591TimelineData);
  }, []);

  return (
    <div className="gpd-x27321591 gpd-component gpd-component-wrapper not-ready">
        <div className="gpd-button-i2732159151-VMUhEc gpd-valign-text-middle">{children}</div>
    </div>
  );
}

const x27321591TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".gpd-x27321591",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {
          "": {
            position: "relative",
          },
        },
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer32(props) {
//   const { group32Props, frame5Props, frame6Props, frame7Props } = props;

//   return (
//     <div className="gpd-footer">
//       <div className="gpd-frame-1585">
//         <Frame1578
//           overlapGroup1={group32Props.overlapGroup1}
//           vector2={group32Props.vector2}
//           group86222Props={group32Props.group86222Props}
//           facebookAppSymbol3Props={group32Props.facebookAppSymbol3Props}
//           twitter3Props={group32Props.twitter3Props}
//         />
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Frame1578(props) {
  const { overlapGroup1, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

  return (
    <div className="gpd-frame-1578">
      <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
      <div className="gpd-frame-1584">
        <Group324 />
        <div className="gpd-frame-1583">
          <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
          <div className="gpd-instagram">
            <div className="gpd-overlap-group2-2" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img
                className="gpd-vector-4"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-56@2x.svg"
              />
              <img className="gpd-vector-5" src={vector2} />
            </div>
          </div>
          <Twitter3 src={twitter3Props.src} />
        </div>
      </div>
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="gpd-group-86">
      <White src={whiteProps.src} />
      <img className="gpd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="gpd-white">
      <img className="gpd-vector-6" src={src} />
    </div>
  );
}


function Group324() {
  return (
    <div className="gpd-group-32">
      <div className="gpd-group-189">
        <div className="gpd-map-pin-1">
          <div className="gpd-overlap-group2-3">
            <img
              className="gpd-vector-7"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-51@2x.svg"
            />
          </div>
        </div>
        <p className="gpd-text-11 gpd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="gpd-group-18">
        <div className="gpd-phone">
          <img
            className="gpd-vector-8"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg"
          />
        </div>
        <div className="gpd-text-1-1 gpd-valign-text-middle gpd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="gpd-group-18">
        <div className="gpd-mail">
          <div className="gpd-overlap-group2-4">
            <img
              className="gpd-vector-9"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-54@2x.svg"
            />
          </div>
        </div>
        <div className="gpd-text-1-1 gpd-valign-text-middle gpd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="gpd-facebook-app-symbol">
      <img className="gpd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="gpd-twitter">
      <img className="gpd-vector-10" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="gpd-frame-5">
      <div className="gpd-text-14 gpd-valign-text-middle gpd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="gpd-frame-4">
      <div className="gpd-text-2 gpd-valign-text-middle gpd-typographybody16-regular">{text41}</div>
      <div className="gpd-text-3 gpd-valign-text-middle gpd-typographybody16-regular">{text42}</div>
      <div className="gpd-text-3 gpd-valign-text-middle gpd-typographybody16-regular">{text43}</div>
      <div className="gpd-text-3 gpd-valign-text-middle gpd-typographybody16-regular">{text44}</div>
      <div className="gpd-text-3 gpd-valign-text-middle gpd-typographybody16-regular">{text45}</div>
      <div className="gpd-text-3 gpd-valign-text-middle gpd-typographybody16-regular">{text46}</div>
      <div className="gpd-text-3 gpd-valign-text-middle gpd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="gpd-frame-6">
      <div className="gpd-text-22 gpd-valign-text-middle gpd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="gpd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`gpd-frame-4-1 ${className || ""}`}>
      <div className="gpd-text-23 gpd-valign-text-middle gpd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="gpd-frame-1580">
        <div className="gpd-text-2-1 gpd-valign-text-middle gpd-typographybody16-regular">{text50}</div>
        <div className="gpd-place gpd-valign-text-middle gpd-typographybody16-regular">{place}</div>
        <div className="gpd-text-25 gpd-valign-text-middle gpd-typographybody16-regular">{text51}</div>
        <div className="gpd-text-26 gpd-valign-text-middle gpd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="gpd-frame-7">
      <div className="gpd-text-30 gpd-valign-text-middle gpd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


// function HeaderWithBackground9(props) {
//   const {
//     unselectedI2732160,
//     unselectedI27321602,
//     unselectedI27321603,
//     text589,
//     unselectedI27321604,
//     unselectedI27321605,
//     unselectedI27321606,
//     unselectedI27321607,
//     group86Props,
//     getAQuoteButton6Props,
//   } = props;

//   return (
//     <div className="gpd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="gpd-frame-34">
//         <div className="gpd-frame-27">
//           <Link to="/">
//           <div className="gpd-unselected-i2732160 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI2732160}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="gpd-unselected-i2732160-1 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI27321602}
//           </div>
//           </Link>
//           <Link to="/project">
//           <div className="gpd-unselected-i2732160-2 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI27321603}
//           </div>
//           </Link>
//           <div className="gpd-selected">
//             <div className="gpd-overlap-group1-1">
//               <div className="gpd-rectangle-61"></div>
//               <div className="gpd-text-39 gpd-valign-text-middle gpd-overpass-bold-shark-14px">{text589}</div>
//             </div>
//           </div>
//           <Link to="/insight">
//           <div className="gpd-unselected-i2732160-3 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI27321604}
//           </div>
//           </Link>
//           <Link to="/blog">
//           <div className="gpd-unselected-i2732160-4 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI27321605}
//           </div>
//           </Link>
//           <Link to="/faq">
//           <div className="gpd-unselected-i2732160-5 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI27321606}
//           </div>
//           </Link>
//           <Link to="/contactus">
//           <div className="gpd-unselected-i2732160-6 gpd-valign-text-middle gpd-typography-body-smalltext-14-regular">
//             {unselectedI27321607}
//           </div>
//           </Link>
//         </div>
//         <GetAQuoteButton6>{getAQuoteButton6Props.children}</GetAQuoteButton6>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="gpd-group-86-1">
      <White src={whiteProps.src} />
      <img className="gpd-group-85-1" src={group85} />
    </div>
  );
}


function GetAQuoteButton6(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2732160964120TimelineData);
  }, []);

  return (
    <div className="gpd-i27321609-64120 gpd-component gpd-component-wrapper not-ready">
      <div className="gpd-master-button-2FhSjx">
        <div className="gpd-button-i2732160964-zRAgiv gpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2732160964120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".gpd-i27321609-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];

const antDesignplayCircleOutlinedData = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnailData = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83@2x.png",
    className: "",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlinedData,
};

const youtubeCardData = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnailProps: youtubeThumbnailData,
};

const antDesignplayCircleOutlined2Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail2Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-1@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined2Data,
};

const youtubeCard2Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpd-youtube-card-1",
    youtubeThumbnailProps: youtubeThumbnail2Data,
};

const antDesignplayCircleOutlined3Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail3Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-2@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined3Data,
};

const youtubeCard3Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpd-youtube-card-1",
    youtubeThumbnailProps: youtubeThumbnail3Data,
};

const antDesignplayCircleOutlined4Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail4Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-3@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined4Data,
};

const youtubeCard4Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnailProps: youtubeThumbnail4Data,
};

const antDesignplayCircleOutlined5Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail5Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-4@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined5Data,
};

const youtubeCard5Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpd-youtube-card-1",
    youtubeThumbnailProps: youtubeThumbnail5Data,
};

const antDesignplayCircleOutlined6Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail6Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-5@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined6Data,
};

const youtubeCard6Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpd-youtube-card-1",
    youtubeThumbnailProps: youtubeThumbnail6Data,
};

const button22Data = {
    children: "VIEW MORE",
};

const antDesignplayCircleOutlined7Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail7Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-6@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined7Data,
};

const youtubeCard7Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    youtubeThumbnailProps: youtubeThumbnail7Data,
};

const antDesignplayCircleOutlined8Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail8Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-7@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined8Data,
};

const youtubeCard8Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpd-youtube-card-1",
    youtubeThumbnailProps: youtubeThumbnail8Data,
};

const antDesignplayCircleOutlined9Data = {
    overlapGroup3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
};

const youtubeThumbnail9Data = {
    youtubeThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-8@2x.png",
    className: "gpd-youtube-thumbnail",
    antDesignplayCircleOutlinedProps: antDesignplayCircleOutlined9Data,
};

const youtubeCard9Data = {
    text129: "Lorem Ipsum passages of Lorem Ipsum available",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    className: "gpd-youtube-card-1",
    youtubeThumbnailProps: youtubeThumbnail9Data,
};

const button82Data = {
    children: "MORE VIDEOS",
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: whiteData,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-117@2x.svg",
};

const frame1578Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-57@2x.svg",
    group86222Props: group86222Data,
    facebookAppSymbol3Props: facebookAppSymbol3Data,
    twitter3Props: twitter3Data,
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "gpd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     group32Props: frame1578Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: white2Data,
};

const getAQuoteButton6Data = {
    children: "GET A QUOTE",
};

// const headerWithBackground9Data = {
//     unselectedI2732160: "HOME",
//     unselectedI27321602: "ABOUT US",
//     unselectedI27321603: "PROJECTS",
//     text589: "VIDEOS",
//     unselectedI27321604: "INSIGHTS",
//     unselectedI27321605: "BLOGS",
//     unselectedI27321606: "FAQ’S",
//     unselectedI27321607: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton6Props: getAQuoteButton6Data,
// };

const x05GalleryPageDesktopData = {
    videos: "Videos",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-113@2x.svg",
    group216: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/group-216@2x.jpg",
    text551: "Lorem Ipsum passages of Lorem Ipsum available",
    latestVideos: "LATEST VIDEOS",
    address: "1034 Views / 24 May 2021 / 45 Comments",
    antDesignPlayCircleOutlined: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/ant-design-play-circle-outlined@2x.svg",
    text588: "We are thrilled to share our videos with you here.",
    text5882: "These videos showcase our belief in transparency and quality of service. We believe that luxury does not have to mean exorbitant expense. With decades of knowledge and expertise as a third-generation family-owned fully-integrated construction firm in Bengaluru, the WeBuildd team leverages time and cost efficiencies to create properties that represent affordable luxury.",
    text5883: "Our team meticulously plans each stage of the construction process to ensure nothing challenges cost or timing decided with the client. We understand everyone has their unique expectations on what they want. With new technologies, customers are intelligent now. And we are continuously striving to fit their needs and wants. So, at WeBuildd, we are committed to bringing exceptional building solutions for our customers.",
    text5884: "The videos featured here are an engaging series of videos that showcase our previous and current projects. Browse now!",
    line4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    line7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-104@2x.svg",
    group: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-103@2x.svg",
    line8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4-1@1x.svg",
    youtubeCardProps: youtubeCardData,
    youtubeCard2Props: youtubeCard2Data,
    youtubeCard3Props: youtubeCard3Data,
    youtubeCardProps2: youtubeCard4Data,
    youtubeCard2Props2: youtubeCard5Data,
    youtubeCard3Props2: youtubeCard6Data,
    button22Props: button22Data,
    youtubeCardProps3: youtubeCard7Data,
    youtubeCard2Props3: youtubeCard8Data,
    youtubeCard3Props3: youtubeCard9Data,
    button82Props: button82Data,
    //footer32Props: footer32Data,
    //headerWithBackground9Props: headerWithBackground9Data,
};

